import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ProgramCreationMainView } from '../../views';
import {CHAT_TYPE, LOCAL_STORAGE_KEYS, PBDQ3_PROGRAM_STATE, PROGRAM_STATUS} from "../../utils/constants";
import { useHistory } from "react-router-dom";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import {
    CurationPromptPublicService,
    fetchFingerprintService,
    registerFingerprintService
} from "../../services/public.service";

const ProgramCreationMain = () => {

    const history = useHistory();
    const [chatHistory, setChatHistory] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [isBotThinking, setIsBotThinking] = useState(false);

    useEffect(() => {
        setShowLoader(true);
        initializeChatHistory().then(resp => setShowLoader(false)).catch(err => setShowLoader(false));
    }, []);

    const initializeChatHistory = async () => {
        setShowLoader(true);
        const fingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.user_fingerprint);
        if (fingerprint) {
            // Fetch the chat history from the server using the fingerprint
            await fetchChatHistory(fingerprint);
        } else {
            const newFingerprint = await createFingerprint();
            console.log('Generated fingerprint:', newFingerprint);
            localStorage.setItem(LOCAL_STORAGE_KEYS.user_fingerprint, newFingerprint);
            await registerFingerprint(newFingerprint);
        }
        setShowLoader(false);
    };

    // Fetch chat history from the server using the fingerprint
    const fetchChatHistory = async (fingerprint) => {
        try {
            const response = await fetchFingerprintService(fingerprint);
            if (response.data && response.data.existingProgram) {
                console.log('finger print fetched successfully');
                console.log('program_fetched: ', response.data.existingProgram);

                if (response.data.existingProgram.program_state > PBDQ3_PROGRAM_STATE.PROGRAM_DRAFT) {
                    history.push('/program-dashboard');
                }

                if (response.data.allMsgs) {
                    const formattedMessages = response.data.allMsgs.map(msg => ({
                        type: msg.sender_type,
                        text: msg.message
                    }));
                    setChatHistory([...chatHistory, ...formattedMessages]);
                }
            }
        } catch (e) {
            // already toasted the error
        }
    };

    // Create a unique fingerprint for the user
    const createFingerprint = async () => {
        return uuidv4();
    };

    // Register the new fingerprint on the server
    const registerFingerprint = async (fingerprint) => {
        try {
            const response = await registerFingerprintService(fingerprint);
            if (response.data && response.data.newProgram) {
                console.log('finger print registered successfully');
                console.log('program_created: ', response.data.newProgram);
            }
        } catch (e) {
            // already toasted the error
        }
    }

    const data = {
        programTitle: 'Digital Literacy Program',
        chats: chatHistory
    };

    const options = {
        height: '570px', //small, medium, large sm/md/lg
        chatType: 'programCreation',
        showChatbotLoader: isBotThinking
    };

    const actions = {
        sendMessageAction: async (message) => {
            if (message === 'clear') {
                localStorage.clear();
                window.location.reload();
            }

            else {

                setChatHistory([...chatHistory, { type: CHAT_TYPE.USER, text: message }]);
                setIsBotThinking(true);
                const fingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.user_fingerprint);
                try {
                    const result = await CurationPromptPublicService(fingerprint, message);
                    if (result.data && result.data.allMsgs) {
                        console.log('response fetched successfully');
                        console.log('allMsgs: ', result.data.botMsg);

                        const formattedMessages = result.data.allMsgs.map(msg => ({
                            type: msg.sender_type,
                            text: msg.message
                        }));
                        setChatHistory([...formattedMessages]);
                    }
                    if (result.data && result.data.redirect_to_outline) {
                        history.push('/program-outline');
                    }

                } catch (e) {
                    // already toasted the error
                }

                setIsBotThinking(false);

            }

        }
    }

    if (showLoader) {
        return <Loader />;
    }
    return (
        <div>
            <ProgramCreationMainView
                data={data}
                actions={actions}
                options={options}
            />
        </div>
    );
};

export default ProgramCreationMain;